import { type ApiConfig, baseApiConfig } from "core/modules/config/apiConfig"

export const oauthApiConfig: ApiConfig = {
  ...baseApiConfig,
  apiRelativePath: ["oauth"]
}
